import type { DeepPartial } from '@luna/utils-ts';

import type { ContactDataManagementFeatureConfig } from './type';

export const contactDataManagement: DeepPartial<ContactDataManagementFeatureConfig> = {
    address: {
        additionalFields: true,
        countyField: true,
        streetTypeField: true,
        streetNumberField: true,
    },
};
